
import {getMaxId} from '@/utils/paperUtil'

function updatePaperList(data) {
    // let fromDataJSON = localStorage.getItem('questionData');
    // if (fromDataJSON){
    //     let fromData_ = JSON.parse(fromDataJSON);
    //     fromData_.logicList = data
    //     localStorage.setItem('questionData', JSON.stringify(fromData_));
    // }
}

export default {
    namespaced: true,
    state: {
        logicList: [],
        id: 1,
    },
    getters: {
        currentLogicList: (state) => (paperId) => {
            return state.logicList && state.logicList.length ? _.cloneDeep(state.logicList.filter(item => item.mainId === paperId)) : []
        }
    },
    mutations: {
        init(state, { data, id }) {
            state.logicList = data
            state.id = id
        },
        add(state, data) {
            if (data) {
                data.id = state.id
                data.sort = state.logicList.filter(item => item.id === data.mainId).length
                state.logicList.push(data)
                state.id++
                updatePaperList(state.logicList)
            }
        },
        update(state, logic) {
            if (logic) {
                const index = state.logicList.findIndex(item => item.id === logic.id)
                if (index >= 0) {
                    state.logicList.splice(index, 1, logic)
                    updatePaperList(state.logicList)
                }
            }
        },
        remove(state, id) {
            const index = state.logicList.findIndex(item => item.id === id)
            if (index >= 0) {
                state.logicList.splice(index, 1)
                updatePaperList(state.logicList)
            }
        },
        removeByPaperId(state, paperId) {
            //1. 删除题目mainId
            state.logicList = state.logicList.filter((item) => item.mainId !== paperId)
            //2. 删除关联题目controlIds
            state.logicList.forEach((item) => {
                item.controlIds = _.difference(item.controlIds, [paperId])
            })
            updatePaperList(state.logicList)
        }
    },
    actions: {
        init({ state, rootState, commit,  dispatch,   getters, rootGetters }, logicList) {
            // 初始化
            if (logicList && logicList.length) {
                let maxId = getMaxId(logicList)
                const id = ++maxId
                commit('init', {
                    data: logicList,
                    id: id
                })
            }
        },
        add({ state, rootState, commit,  dispatch,   getters, rootGetters }) {

        }
    }
}
